<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
   <b-overlay :show="loading" rounded="sm" class="w-100 h-100">
  <div style="height: inherit;">
    <div
      class="body-content-overlay"
      :class="{'show': shallShowUserProfileSidebar || shallShowActiveChatContactSidebar || mqShallShowLeftSidebar}"
      @click="mqShallShowLeftSidebar=shallShowActiveChatContactSidebar=shallShowUserProfileSidebar=false"
    />

    <!-- Main Area -->
    <section class="chat-app-window" ref="chatAppWindowEl">

      <!-- Start Chat Logo -->
      <div
        v-if="conversations.length == 0"
        class="start-chat-area"
      >
        <div class="mb-1 start-chat-icon">
          <feather-icon
            icon="MessageSquareIcon"
            size="56"
             @click="startConversation"
          />
        </div>

      </div>

      <!-- Chat Content -->
      <div
        v-else
        class="active-chat"
      >
        <!-- Chat Navbar -->
        <div class="chat-navbar">
          <header class="chat-header">

            <!-- Avatar & Name -->
            <div class="d-flex align-items-center">

              <!-- Toggle Icon -->
              <div class="sidebar-toggle d-block d-lg-none mr-1">
                <feather-icon
                  icon="MenuIcon"
                  class="cursor-pointer"
                  size="21"
                  @click="mqShallShowLeftSidebar = true"
                />
              </div>

              <b-avatar
                size="36"
                class="mr-2 cursor-pointer badge-minimal"
                @click.native="shallShowActiveChatContactSidebar=true"
                :src="'https://rb.cloudedu.pro/studentPhoto/' + conversations[0].uuid + '.jpg'"
              />
                  
                <h6 class="mb-0">  
                  {{ conversations[0].student_zh_name + ' - ' + selected_customer }}
                </h6>    
                 <font-awesome-icon
                 v-if="conversations[0].is_pinned === true"
                  icon="fa-solid fa-thumbtack"
                  class="text-danger ml-75 cursor-pointer"
                  @click="change_pin('unpin')"
                  />
                  <font-awesome-icon
                 v-if="conversations[0].is_pinned === false"
                  icon="fa-solid fa-thumbtack"
                  class="ml-75 cursor-pointer"
                  @click="change_pin('pin')"
                  />
                  <font-awesome-icon
                  icon="fa-solid fa-eye-slash"
                  class="ml-75 cursor-pointer"
                  @click="unread()"
                  />
                <!-- <b-badge v-if="!conversations[0].student_zh_name" variant="light-danger" >未有負責分校</b-badge> -->
            
            </div>

            <!-- Contact Actions -->
            <div class="d-flex align-items-center">
              <v-select v-if="!conversations[0].student_zh_name" 
              v-model="changed_center" 
              :options="centerOptions" 
              style="min-width:200px;" 
              :clearable="false" 
              class="select-size-sm" 
              :filterable="false" />
            </div>
          </header>
        </div>

        <!-- User Chat Area -->
        <vue-perfect-scrollbar
          ref="refChatLogPS"
          :settings="perfectScrollbarSettings"
          class="user-chats scroll-area"
          @ps-y-reach-start="loadMoreConversations"
        >
          <chat-log
            :chat-data="conversations"
            :customer-data="selected_customer_data"
          />
          <div v-if="uploadedPreviewUrl" class="upload-preview-card">
            <div class="preview-left">
              <!-- Image -->
              <img
                v-if="isImageUpload"
                :src="uploadedPreviewUrl"
                class="preview-media"
                alt="preview"
              />

              <!-- Video -->
              <video
                v-else-if="isVideoUpload"
                :src="uploadedPreviewUrl"
                class="preview-media"
                controls
              />

              <!-- File -->
              <div v-else class="file-chip">
                📄 {{ uploadedFileName }}
              </div>
            </div>

            <div class="preview-right">
              <div class="file-name" :title="uploadedFileName">
                {{ uploadedFileName }}
              </div>

              <b-button
                size="sm"
                variant="outline-danger"
                class="remove-btn"
                @click.prevent="clearUpload"
              >
                ✕ Remove
              </b-button>
            </div>
          </div>
        </vue-perfect-scrollbar>
      
        <!-- Preview -->
        <!-- Message Input -->
        <b-form ref="chatFormEl" class="chat-app-form chat-app-form--flex" @submit.prevent="handleSubmit">
          <div class="chat-send-row">
            <draggable
              :list="dropSink"
              :sort="false"
              class="vd-drop-zone"
              tag="div"
            >
              <div
                class="vd-drop-box"
                :class="{ dragging: isDragging }"
                @dragover.prevent="onDragOver"
                @dragenter.prevent="onDragEnter"
                @dragleave.prevent="onDragLeave"
                @drop.prevent="handleDrop"
              >
                  <b-form-textarea
                    v-model="chatInputMessage"
                    :class="{ 'chat-expired-textarea': isConversationWindowExpired }"
                    rows="1"
                    max-rows="6"
                    no-resize
                    :placeholder="isConversationWindowExpired ? '已超過24小時，下一個訊息會以範本形式發出' : 'Enter your message (Alt+Enter for new line, Enter to send)'"
                    @keydown.enter.exact.prevent="handleSubmit"
                  />
              </div>
            </draggable>

            <b-button
              class="emoji-btn"
              variant="outline-secondary"
              type="button"
              @click="openEmojiPicker"
            >
              😀
            </b-button>

            <b-button
              class="send-btn"
              :class="{ 'send-btn--disabled': isSending }"
              variant="primary"
              type="submit"
              :disabled="(!chatInputMessage && !hasUpload) || isSending || isPhotoSendBlocked"
            >
              <template v-if="isSending">
                <font-awesome-icon icon="fa-solid fa-spinner" spin class="mr-50" />
              </template>
              <template v-else>
                Send
              </template>
            </b-button>
          </div>
        </b-form>

        <b-modal
          id="emoji-picker-modal"
          title="Choose Emoji"
          centered
          size="lg"
          hide-footer
        >
          <div v-if="frequentEmojiList.length" class="emoji-section mb-1">
            <div class="emoji-section-title">Frequently Used</div>
            <div class="emoji-grid emoji-grid--frequent">
              <button
                v-for="emoji in frequentEmojiList"
                :key="`frequent-${emoji}`"
                type="button"
                class="emoji-item"
                @click="insertEmoji(emoji)"
              >
                {{ emoji }}
              </button>
            </div>
          </div>

          <div class="emoji-section-title">All Emoji</div>
          <div v-if="isEmojiLoading" class="emoji-loading">Loading emojis...</div>
          <div v-else class="emoji-grid">
            <button
              v-for="emoji in emojiList"
              :key="emoji"
              type="button"
              class="emoji-item"
              @click="insertEmoji(emoji)"
            >
              {{ emoji }}
            </button>
          </div>
        </b-modal>
      </div>
    </section>

    <!-- Active Chat Contact Details Sidebar -->
    <chat-active-chat-content-details-sidedbar
      :shall-show-active-chat-contact-sidebar.sync="shallShowActiveChatContactSidebar"
      :contact="activeChat.contact || {}"
      :customer="selected_customer || ''"
    />

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <chat-left-sidebar
        :chats-contacts="chatsContacts"
        :active-chat-contact-id="activeChat.contact ? activeChat.contact.id : null"
        :shall-show-user-profile-sidebar.sync="shallShowUserProfileSidebar"
        :profile-user-data="profileUserData"
        :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
        @show-user-profile="showUserProfileSidebar"
        @filter-contact="filterContact"
        @search-mobile="searchMobile"
        @open-chat="openChatOfContact"
        :has-more="hasMore"
        :is-loading="isLoadingContacts"
        @load-more="getContacts"
      />
    </portal>
  </div>
  </b-overlay>
</template>

<script>
  import { computed, watch } from '@vue/composition-api'
import {
  ref, onMounted,onUnmounted, nextTick, getCurrentInstance,
} from '@vue/composition-api'
import {
  BRow,BCol,BAvatar, BDropdown, BDropdownItem, BForm, BInputGroup, BFormTextarea, BButton,BOverlay,BBadge
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
// import { formatDate } from '@core/utils/filter'
import { $themeBreakpoints } from '@themeConfig'
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
import store from '@/store'
import ChatLeftSidebar from './ChatLeftSidebar.vue'
import chatStoreModule from './chatStoreModule'
import ChatActiveChatContentDetailsSidedbar from './ChatActiveChatContentDetailsSidedbar.vue'
import ChatLog from './ChatLog.vue'
import useChat from './useChat'
import { postRequest } from './axios.js'
import { sendWhatsappMediaMessage, sendWhatsappTextMessage } from './sendMessageApi'
import draggable from 'vuedraggable' 
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    draggable,
    vSelect,
    // BSV
    BAvatar,
    ToastificationContent,
    BOverlay,
    BDropdown,
    BDropdownItem,
    BForm,
    BBadge,
    BInputGroup,
    BFormTextarea,
    BButton,
    BRow,
    BCol,
    // 3rd Party
    VuePerfectScrollbar,

    // SFC
    ChatLeftSidebar,
    ChatActiveChatContentDetailsSidedbar,
    ChatLog,
  },
  setup() {
    const CHAT_APP_STORE_MODULE_NAME = 'app-chat'
    const dropSink = ref([{ id: 'sink' }]) // required by vuedraggable
    const chatAppWindowEl = ref(null)
    const chatFormEl = ref(null)
    const isDragging = ref(false)
    const loading = ref(false)
    const hasUpload = ref(false)
    const isImageUpload = ref(false)
    const isVideoUpload = ref(false)
    const uploadedFileName = ref(null)
    const uploadedPreviewUrl = ref(null)
    const centerOptions = ref([])
    const changed_center = ref(null)
    const isHydratingCenter = ref(false)
    const uploadedFile = ref({
      file: null, 
      base64: null,
      preview: null,
      file_type: null,
      file_name: null,
    })
    const isSending = ref(false)
    const reloadingConversations = ref(false)
    const isProgrammaticScroll = ref(false)
    const dragDepth = ref(0)
    let dragEndTimer = null
    let formResizeObserver = null
    let whatsappWatchTimer = null
    let lastWhatsappId = ''
    const pauseConversationReloadUntil = ref(0)
    
    const lastWhatsappJson = computed(() => {
      return store.getters['whatsapp/last_whatsapp_json']
    })
    
    watch(lastWhatsappJson, (newVal, oldVal) => {
      if (!newVal) return
      //console.log('📩 last_whatsapp_json changed:', newVal)
      debounceReloadContacts()
      
      if (Date.now() < pauseConversationReloadUntil.value) {
        return
      }

      if (isSameNumber(newVal.contact_number, selected_customer.value)) {
        debounceReloadConversations(activeContact.value)
      } 
    })

    function extractCenterId(option) {
      if (option && typeof option === 'object') {
        if (option.value !== undefined && option.value !== null) return Number(option.value)
        if (option.id !== undefined && option.id !== null) return Number(option.id)
        if (option.center_id !== undefined && option.center_id !== null) return Number(option.center_id)
      }
      return Number(option)
    }

    function findCenterOptionById(centerId) {
      const targetId = Number(centerId)
      if (!targetId || Number.isNaN(targetId)) return null
      return centerOptions.value.find(option => extractCenterId(option) === targetId) || null
    }

    watch(changed_center, async (newVal, oldVal) => {
      if (isHydratingCenter.value) return
      if (newVal === null || newVal === undefined) return
      if (newVal === oldVal) return
      if (!vm || !vm.$http) return
      if (!selected_customer.value) return

      const centerId = extractCenterId(newVal)
      if (!centerId || Number.isNaN(centerId)) return

      await vm.$http.post(process.env.VUE_APP_API_BASE + '/whatsapp/lead-center/', {
        number: selected_customer.value,
        center_id: centerId,
      })

      if (activeContact.value) {
        activeContact.value = {
          ...activeContact.value,
          lead_center_id: centerId,
          center_id: centerId,
        }
      }

      if (selected_customer_data.value) {
        selected_customer_data.value = {
          ...selected_customer_data.value,
          lead_center_id: centerId,
          center_id: centerId,
        }
      }

      debounceReloadContacts()
    })

    const normalizeNumber = value => String(value || '').replace(/\D/g, '')
    function isSameNumber(a, b) {
      const aa = normalizeNumber(a)
      const bb = normalizeNumber(b)
      if (!aa || !bb) return false
      return aa === bb || aa.endsWith(bb) || bb.endsWith(aa)
    }
    function refreshAfterSubmit() {
      debounceReloadContacts()
      if (selected_customer.value) {
        debounceReloadConversations(activeContact.value)
      }
    }

    const emojiList = ref([
      '😀', '😁', '😂', '🤣', '😊', '😍', '😘', '😎',
      '🤩', '😇', '🥳', '🤗', '🤔', '🙌', '👍', '👏',
      '🙏', '💪', '🔥', '❤️', '💙', '💚', '🎉', '✅',
    ])
    const frequentEmojiList = ref([])
    const isEmojiLoading = ref(false)
    const hasLoadedAllEmoji = ref(false)
    const frequentEmojiStorageKey = 'chat-frequent-emojis'

    function loadFrequentEmoji() {
      try {
        const raw = localStorage.getItem(frequentEmojiStorageKey)
        const parsed = JSON.parse(raw || '[]')
        if (Array.isArray(parsed)) {
          frequentEmojiList.value = parsed.filter(item => typeof item === 'string' && item !== '').slice(0, 18)
        }
      } catch (error) {
        frequentEmojiList.value = []
      }
    }

    function saveFrequentEmoji() {
      try {
        localStorage.setItem(frequentEmojiStorageKey, JSON.stringify(frequentEmojiList.value))
      } catch (error) {
        // ignore storage errors
      }
    }

    function updateFrequentEmoji(emoji) {
      const next = [emoji, ...frequentEmojiList.value.filter(item => item !== emoji)]
      frequentEmojiList.value = next.slice(0, 18)
      saveFrequentEmoji()
    }
    async function change_pin(action) {
      if (!vm || !vm.$http || !selected_customer.value) return

      const response = await vm.$http.post(process.env.VUE_APP_API_BASE + '/whatsapp/pin/', {
        action,
        from: selected_customer.value,
      })

      if (response.status === 200) {
        const pinned = action === 'pin'
        if (Array.isArray(conversations.value) && conversations.value.length > 0) {
          conversations.value = conversations.value.map(item => ({ ...item, is_pinned: pinned }))
        }
        if (activeContact.value) {
          activeContact.value = { ...activeContact.value, is_pinned: pinned }
        }
        if (selected_customer_data.value) {
          selected_customer_data.value = { ...selected_customer_data.value, is_pinned: pinned }
        }
        debounceReloadContacts()
      }
    }
    async function unread() {
      if (!vm || !vm.$http || !selected_customer.value) return

      // Keep unread action lightweight: refresh contact list only.
      pauseConversationReloadUntil.value = Date.now() + 1500
      const response = await vm.$http.post(process.env.VUE_APP_API_BASE + '/whatsapp/unread/', {
        from: selected_customer.value,
      })

      if (response.status === 200) {
        debounceReloadContacts()
      }
    }
    async function loadAllEmoji() {
      if (hasLoadedAllEmoji.value || isEmojiLoading.value) return
      isEmojiLoading.value = true
      try {
        const response = await fetch('https://cdn.jsdelivr.net/npm/emoji.json@13.1.0/emoji.json')
        const data = await response.json()
        if (Array.isArray(data)) {
          const fullEmoji = data
            .map(item => item && item.char)
            .filter(char => typeof char === 'string' && char !== '')

          const toneModifiers = ['🏻', '🏼', '🏽', '🏾', '🏿']
          const preferredTone = '🏼' // medium-light tone, e.g. 👌🏼
          const byBaseEmoji = new Map()

          for (const emoji of fullEmoji) {
            const baseEmoji = emoji.replace(/[🏻🏼🏽🏾🏿]/g, '')
            const selected = byBaseEmoji.get(baseEmoji)

            if (!selected) {
              byBaseEmoji.set(baseEmoji, emoji)
              continue
            }

            const selectedHasPreferred = selected.indexOf(preferredTone) !== -1
            const currentHasPreferred = emoji.indexOf(preferredTone) !== -1
            if (!selectedHasPreferred && currentHasPreferred) {
              byBaseEmoji.set(baseEmoji, emoji)
              continue
            }

            const selectedHasTone = toneModifiers.some(tone => selected.indexOf(tone) !== -1)
            const currentHasTone = toneModifiers.some(tone => emoji.indexOf(tone) !== -1)

            // If no preferred tone exists, keep neutral/non-tone version when possible.
            if (!selectedHasPreferred && !currentHasPreferred && selectedHasTone && !currentHasTone) {
              byBaseEmoji.set(baseEmoji, emoji)
            }
          }

          const filteredEmoji = Array.from(byBaseEmoji.values())
          if (fullEmoji.length > 0) {
            emojiList.value = Array.from(new Set(filteredEmoji))
            hasLoadedAllEmoji.value = true
          }
        }
      } catch (error) {
        // keep fallback emojis when loading fails
      } finally {
        isEmojiLoading.value = false
      }
    }

    async function openEmojiPicker() {
      await loadAllEmoji()
      if (!vm || !vm.$bvModal) return
      vm.$bvModal.show('emoji-picker-modal')
    }

    function insertEmoji(emoji) {
      const currentMessage = chatInputMessage.value || ''
      chatInputMessage.value = `${currentMessage}${emoji}`
      updateFrequentEmoji(emoji)
      if (vm && vm.$bvModal) {
        vm.$bvModal.hide('emoji-picker-modal')
      }
    }

    function debounceReloadConversations(contact) {
      if (reloadingConversations.value) return
      reloadingConversations.value = true
      setTimeout(async () => {
        await getUpdatedConversations(contact)
        reloadingConversations.value = false
        await scrollToBottomInChatLog()
      }, 300)
    }

    function mapConversationType(rawType) {
      const t = String(rawType || '').toLowerCase()
      if (t === 'voice') return 'audio'
      if (t === 'pdf') return 'document'
      return t || 'text'
    }

    function inferConversationDirection(row, phoneNumber) {
      const target = normalizeNumber(phoneNumber)
      const fromNumber = normalizeNumber(row && row.from)
      const toNumber = normalizeNumber(row && row.to)
      if (target && fromNumber && (target === fromNumber || target.endsWith(fromNumber) || fromNumber.endsWith(target))) {
        return 'in'
      }
      if (target && toNumber && (target === toNumber || target.endsWith(toNumber) || toNumber.endsWith(target))) {
        return 'out'
      }
      return 'in'
    }

    function mapConversationItem(row, phoneNumber) {
      const mappedType = mapConversationType(row && row.type)
      return {
        ...row,
        message_id: row && row.id,
        message_type: mappedType,
        message: row && row.body ? row.body : '',
        text: row && row.body ? row.body : '',
        display_url: (row && row.file_url) || (row && row.base64) || '',
        last_time: (row && row.message_at) || (row && row.created_at) || '',
        direction: inferConversationDirection(row, phoneNumber),
      }
    }

    async function fetchConversationsPage(contact, pageIndex = 0) {
      const phoneNumber = contact.whatsapp_mobile
      if (!phoneNumber || !vm || !vm.$http) {
        return {
          ok: false,
          list: [],
          hasMorePage: false,
        }
      }

      const offset = conversation_limit * pageIndex
      const response = await vm.$http.get(process.env.VUE_APP_API_BASE + '/whatsapp-conversations/', {
        params: {
          phone_number: phoneNumber,
          limit: conversation_limit,
          offset,
        },
      })

      if (response.status !== 200) {
        return {
          ok: false,
          list: [],
          hasMorePage: false,
        }
      }

      const rows = Array.isArray(response?.data?.conversations) ? response.data.conversations : []
      return {
        ok: true,
        list: rows.map(row => mapConversationItem(row, phoneNumber)),
        hasMorePage: !!response?.data?.has_more,
      }
    }

    async function refreshUnreadTotalToStorage() {
      if (!vm || !vm.$http) return

      try {
        const response = await vm.$http.get(process.env.VUE_APP_API_BASE + '/whatsapp/unread-total/')
        const unreadTotal = parseInt(response?.data?.unread_total, 10)
        localStorage.setItem('whatsapp_badge_count', Number.isNaN(unreadTotal) ? '0' : String(unreadTotal))
      } catch (error) {
        // ignore badge refresh errors
      }
    }

    async function getUpdatedConversations(contact){
      console.log(contact)
      const result = await fetchConversationsPage(contact, 0)
      if (!result.ok) return
      if (result.list.length) {
        appendOnlyNew(conversations.value, result.list)
      }
      await refreshUnreadTotalToStorage()
    }

    const keyOf = m => m?.id || m?.message_id
    function appendOnlyNew(existing, incoming) {
      if (!Array.isArray(existing) || !Array.isArray(incoming)) return

      const existingIndexMap = new Map()
      existing.forEach((item, index) => {
        const key = keyOf(item)
        if (key) existingIndexMap.set(key, index)
      })

      for (const msg of incoming) {
        const key = keyOf(msg)
        if (!key) continue

        if (!existingIndexMap.has(key)) {
          existing.push(msg)
          existingIndexMap.set(key, existing.length - 1)
          continue
        }

        const targetIndex = existingIndexMap.get(key)
        const oldMsg = existing[targetIndex] || {}

        // Merge latest fields from backend (e.g. status/delivery_status/status_message)
        const mergedMsg = {
          ...oldMsg,
          ...msg,
        }

        const hasChanged =
          oldMsg.status !== mergedMsg.status ||
          oldMsg.delivery_status !== mergedMsg.delivery_status ||
          oldMsg.status_message !== mergedMsg.status_message ||
          oldMsg.last_time !== mergedMsg.last_time ||
          oldMsg.message !== mergedMsg.message

        if (hasChanged) {
          existing.splice(targetIndex, 1, mergedMsg)
        }
      }
    }

    function refreshUploadFlags() {
      hasUpload.value = !!uploadedFile.value.base64
      isImageUpload.value = !!uploadedFile.value.file_type && uploadedFile.value.file_type.indexOf('image/') === 0
      isVideoUpload.value = !!uploadedFile.value.file_type && uploadedFile.value.file_type.indexOf('video/') === 0
      if (
        uploadedFile.value &&
        uploadedFile.value.file_type &&
        uploadedFile.value.file_type.indexOf('application/') === 0
      ) {
        uploadedFileName.value = uploadedFile.value.file_name
      }
    }

    function onDragOver(e) { e.preventDefault() }

    function onDragEnter(e) {
      e.preventDefault()
      dragDepth.value += 1
      isDragging.value = true
      if (dragEndTimer) clearTimeout(dragEndTimer)
    }

    function onDragLeave(e) {
      e.preventDefault()
      dragDepth.value = Math.max(0, dragDepth.value - 1)

      // only turn off when fully left the drop zone
      if (dragDepth.value === 0) {
        // small delay avoids flicker when moving between children
        dragEndTimer = setTimeout(() => {
          isDragging.value = false
        }, 30)
      }
    }

    function handleDrop(e) {
      dragDepth.value = 0
      isDragging.value = false
      const file = e.dataTransfer?.files?.[0]
      if (!file) return

      if (isConversationWindowExpired.value && file.type.startsWith('image/')) {
        return
      }

      const allowed =
        file.type.startsWith('image/') ||
        file.type.startsWith('video/') ||
        file.type.startsWith('application/')
      if (!allowed) return

      chatInputMessage.value = null
      uploadedPreviewUrl.value = URL.createObjectURL(file)

      const reader = new FileReader()
      reader.onload = () => {
        uploadedFile.value = {
          file,
          base64: reader.result, // ✅ BASE64
          preview: URL.createObjectURL(file),
          file_type: file.type,
          file_name: file.name,
        }
        refreshUploadFlags()
      }
      reader.readAsDataURL(file) // 🔥 BASE64 here
      scrollToBottomInChatLog()
    }

    function resetDragging() {
      dragDepth.value = 0
      isDragging.value = false
      if (dragEndTimer) {
        clearTimeout(dragEndTimer)
        dragEndTimer = null
      }
    }

    function clearUpload() {
      if (uploadedPreviewUrl.value) {
        URL.revokeObjectURL(uploadedPreviewUrl.value)
        uploadedPreviewUrl.value = null
      }
      hasUpload.value = null
      
      uploadedFile.value = {
        file: null,
        base64: null,
        preview: null,
        file_type: null,
        file_name: null,
      }
    }

    // Register module
    if (!store.hasModule(CHAT_APP_STORE_MODULE_NAME)) store.registerModule(CHAT_APP_STORE_MODULE_NAME, chatStoreModule)

    function syncComposerHeight() {
      const appEl = chatAppWindowEl.value
      const formRef = chatFormEl.value
      const formEl = formRef && formRef.$el ? formRef.$el : formRef
      if (!appEl || !formEl) return
      const h = Math.ceil(formEl.getBoundingClientRect().height || 65)
      appEl.style.setProperty('--chat-form-height', `${h}px`)
    }
    
    const dropZoneEl = ref(null)
    let onWindowDrop = null
    let onWindowDragEnd = null
    let onWindowDragLeave = null
    let onWindowDragOver = null
    onMounted(async () => {
      await nextTick()
      await get_center_data()
      loadFrequentEmoji()

      syncComposerHeight()
      const formRef = chatFormEl.value
      const formEl = formRef && formRef.$el ? formRef.$el : formRef
      if (formEl && typeof ResizeObserver !== 'undefined') {
        formResizeObserver = new ResizeObserver(() => {
          syncComposerHeight()
        })
        formResizeObserver.observe(formEl)
      }

      lastWhatsappId = localStorage.getItem('whatsapp-id') || ''
      whatsappWatchTimer = setInterval(() => {
        const currentWhatsappId = localStorage.getItem('whatsapp-id') || ''
        if (currentWhatsappId && currentWhatsappId !== lastWhatsappId) {
          lastWhatsappId = currentWhatsappId
          console.log('new message')
          debounceReloadContacts()
          console.log('selected_customer.value', selected_customer.value)
          if (selected_customer.value && Date.now() >= pauseConversationReloadUntil.value) {
            debounceReloadConversations(activeContact.value)
          }
        }
      }, 500)

      // ✅ 1) Global safety: if user drops outside / leaves window, reset
      onWindowDrop = () => resetDragging()
      onWindowDragEnd = () => resetDragging()
      onWindowDragLeave = e => {
        // when leaving the browser window, clientX/clientY often becomes 0
        if (e.clientX === 0 && e.clientY === 0) resetDragging()
      }
      onWindowDragOver = e => {
        // allow drop anywhere (otherwise drop event may not fire)
        e.preventDefault()
      }

      window.addEventListener('drop', onWindowDrop)
      window.addEventListener('dragend', onWindowDragEnd)
      window.addEventListener('dragleave', onWindowDragLeave)
      window.addEventListener('dragover', onWindowDragOver)

      // ✅ 2) Hard-bind events to the actual drop zone element (most reliable)
      const el = dropZoneEl.value
      if (el) {
        el.addEventListener('dragover', onDragOver)
        el.addEventListener('dragenter', onDragEnter)
        el.addEventListener('dragleave', onDragLeave)
        el.addEventListener('drop', handleDrop)
      }
      const ps = refChatLogPS.value
      const scrollEl = ps?.$el || ps
      if (scrollEl && onScroll) scrollEl.removeEventListener('scroll', onScroll)
    })

    // UnRegister on leave
    onUnmounted(() => {
      if (whatsappWatchTimer) clearInterval(whatsappWatchTimer)
      if (formResizeObserver) {
        formResizeObserver.disconnect()
        formResizeObserver = null
      }

      // remove window listeners
      if (onWindowDrop) window.removeEventListener('drop', onWindowDrop)
      if (onWindowDragEnd) window.removeEventListener('dragend', onWindowDragEnd)
      if (onWindowDragLeave) window.removeEventListener('dragleave', onWindowDragLeave)
      if (onWindowDragOver) window.removeEventListener('dragover', onWindowDragOver)

      // remove drop zone listeners
      const el = dropZoneEl.value
      if (el) {
        el.removeEventListener('dragover', onDragOver)
        el.removeEventListener('dragenter', onDragEnter)
        el.removeEventListener('dragleave', onDragLeave)
        el.removeEventListener('drop', handleDrop)
      }
      const ps = refChatLogPS.value
      const scrollEl = ps?.$el || ps
      if (scrollEl && onScroll) scrollEl.removeEventListener('scroll', onScroll)
    })

    const { resolveAvatarBadgeVariant } = useChat()

    // Scroll to Bottom ChatLog
    const refChatLogPS = ref(null)
    const scrollToBottomInChatLog = async () => {
      isProgrammaticScroll.value = true
      await nextTick()

      const ps = refChatLogPS.value
      const el = ps?.$el || ps
      if (!el) {
        isProgrammaticScroll.value = false
        return
      }

      if (typeof ps?.update === 'function') ps.update()

      // lock to bottom for a few frames (images/video can change height)
      for (let i = 0; i < 4; i++) {
        await new Promise(r => requestAnimationFrame(r))
        el.scrollTop = el.scrollHeight
        if (typeof ps?.update === 'function') ps.update()
      }

      // release after layout settles
      setTimeout(() => (isProgrammaticScroll.value = false), 150)
    }

    // ------------------------------------------------
    // Chats & Contacts
    // ------------------------------------------------
    const activeContact = ref(null)
    const isLoadingConversations = ref(false)
    const chatsContacts = ref([])
    const contacts = ref([])
    const page = ref(0)
    const limit = 20
    const hasMore = ref(true)
    const isLoadingContacts = ref(false)
    const contactListFilter = ref('')
    const contactSearchMobile = ref('')
    const conversation_page = ref(0)
    const conversation_limit = 100
    const hasConversationsMore = ref(true)
    let conversations = ref([])
    let onScroll = null
    const reloadingContacts = ref(false)
    const vm = getCurrentInstance()?.proxy

    function getAllowedCenterIds() {
      try {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}')
        const centers = Array.isArray(userData?.centers) ? userData.centers : []
        return new Set(centers.map(center => String(center?.center_id ?? center?.id ?? center)).filter(Boolean))
      } catch (error) {
        return new Set()
      }
    }

    const normalizeMobile = value => String(value || '').replace(/\D/g, '').replace(/^852/, '')

    function mapWhatsappContactItem(item = {}) {
      const mobile = item.mobile || ''
      const fromNumber = item.from || ''
      const toNumber = item.to || ''
      const direction = normalizeMobile(fromNumber) === normalizeMobile(mobile) ? 'in' : 'out'
      const normalizedType = String(item.type || '').toLowerCase()
      let messageType = normalizedType
      if (normalizedType === 'voice') messageType = 'audio'
      if (normalizedType === 'pdf') messageType = 'document'

      const displayName = item.zh_name || item.en_name || mobile || 'Unknown'
      const lastTime = item.message_at || item.created_at || ''

      return {
        ...item,
        id: Number(item.student_id) || item.student_id,
        lead_center_id: Number(item.lead_center_id || 0) || null,
        display_name: displayName,
        last_time: lastTime,
        message: item.body || '',
        message_type: messageType || 'text',
        unread_count: Number(item.unread_count || 0),
        contact_number: mobile,
        from_number: fromNumber,
        to_number: toNumber,
        direction,
        member: {
          id: item.student_id,
          code: item.code,
          zh_name: item.zh_name,
          en_name: item.en_name,
          mobile: item.mobile,
          center_id: item.center_id || item.lead_center_id,
        },
      }
    }
    async function get_center_data() {
      if (!vm || !vm.$http) return
      try {
        const res = await vm.$http.get(process.env.VUE_APP_API_BASE + '/centers/')
        centerOptions.value = Array.isArray(res?.data?.centers) ? res.data.centers : []
        if (activeContact.value) {
          const leadCenterId = Number(activeContact.value.lead_center_id || activeContact.value.center_id || 0) || null
          if (leadCenterId) {
            isHydratingCenter.value = true
            changed_center.value = findCenterOptionById(leadCenterId)
            await nextTick()
            isHydratingCenter.value = false
          }
        }
      } catch (error) {
        centerOptions.value = []
      }
    }
    async function enrichContactsWithMembers(contacts) {
      const allowedCenterIds = getAllowedCenterIds()
      const mobiles = [...new Set(
        contacts
          .map(contact => normalizeMobile(contact.contact_number || contact.to_number || contact.from_number || contact.mobile))
          .filter(Boolean)
      )]

      if (!mobiles.length || !vm || !vm.$http) {
        return []
      }

      const res = await vm.$http.post('https://rb.cloudedu.pro/api/v1/dev/student/whatsapp_search_students/', { mobiles })

      const members = Array.isArray(res?.data?.members) ? res.data.members : []
      const memberMap = new Map(
        members.map(member => [normalizeMobile(member.mobile), member])
      )

      return contacts.reduce((acc, contact) => {
        const newVal = normalizeMobile(contact.contact_number || contact.to_number || contact.from_number || contact.mobile)
        if (!newVal) return acc

        const member = memberMap.get(newVal)
        if (!member) return acc

        if (member.center_id && !allowedCenterIds.has(String(member.center_id))) {
          return acc
        }

        acc.push({
          ...contact,
          member,
        })
        return acc
      }, [])
    }
    

    async function loadMoreConversations() {
      if (isProgrammaticScroll.value) return
      if (!activeContact.value) return
      await getConversions(activeContact.value, { prepend: true })
    }

    async function fetchContactsPage(pageIndex = 0) {
      if (!vm || !vm.$http) {
        return {
          ok: false,
          list: [],
          hasMorePage: false,
        }
      }

      const offset = pageIndex * limit
      const params = {
        limit,
        offset,
      }
      if (contactListFilter.value) {
        params.filter_contact = contactListFilter.value
      }
      if (contactSearchMobile.value) {
        params.search_mobile = contactSearchMobile.value
      }
      const response = await vm.$http.get(process.env.VUE_APP_API_BASE + '/whatsapp-contact-list/', {
        params,
      })
      if (response.status !== 200) {
        return {
          ok: false,
          list: [],
          hasMorePage: false,
        }
      }

      const rawList = Array.isArray(response?.data?.contact_list) ? response.data.contact_list : []
      const contactsWithMember = rawList.map(mapWhatsappContactItem)
      // Fallback: if API has_more is false but current page is full,
      // keep load-more enabled until a short page is returned.
      const apiHasMore = !!response?.data?.has_more
      const hasMorePage = apiHasMore || rawList.length >= limit

      return {
        ok: true,
        list: contactsWithMember,
        hasMorePage,
      }
    }

    async function getContacts(){
      if (isLoadingContacts.value || !hasMore.value) return
      isLoadingContacts.value = true

      try {
        const result = await fetchContactsPage(page.value)
        if (!result.ok) return

        if (result.list.length) {
          chatsContacts.value.push(...result.list)
          page.value += 1
        }
        hasMore.value = result.hasMorePage
      } finally {
        isLoadingContacts.value = false
      }
    }

    getContacts()

    function debounceReloadContacts() {
      if (reloadingContacts.value) return
      reloadingContacts.value = true
      setTimeout(async () => {
        if (isLoadingContacts.value) {
          reloadingContacts.value = false
          return
        }

        isLoadingContacts.value = true
        try {
          const result = await fetchContactsPage(0)
          if (result.ok) {
            chatsContacts.value = result.list
            page.value = result.list.length ? 1 : 0
            hasMore.value = result.hasMorePage
          }
        } finally {
          isLoadingContacts.value = false
        }
        reloadingContacts.value = false
      }, 300)
    }

    function filterContact(type) {
      const nextFilter = (type === 'unread' || type === 'unreplied') ? type : ''
      if (contactListFilter.value === nextFilter) {
        return
      }
      contactListFilter.value = nextFilter
      chatsContacts.value = []
      page.value = 0
      hasMore.value = true
      debounceReloadContacts()
    }

    function searchMobile(value) {
      const normalizedValue = String(value || '').replace(/\D/g, '')
      if (contactSearchMobile.value === normalizedValue) return

      contactSearchMobile.value = normalizedValue
      chatsContacts.value = []
      page.value = 0
      hasMore.value = true
      debounceReloadContacts()
    }

    // ------------------------------------------------
    // Single Chat
    // ------------------------------------------------
    const activeChat = ref({})
    const chatInputMessage = ref(null)
    const selected_customer = ref(null)
    const selected_customer_data = ref(null)
    const selected_customer_photo = ref(null)
    const isConversationWindowExpired = computed(() => {
      const list = Array.isArray(conversations.value) ? conversations.value : []
      if (!list.length) return false

      let latestIncomingMs = null
      for (const item of list) {
        if (!item || item.direction !== 'in') continue
        const ms = new Date(item.last_time || '').getTime()
        if (Number.isNaN(ms)) continue
        if (latestIncomingMs === null || ms > latestIncomingMs) {
          latestIncomingMs = ms
        }
      }

      if (latestIncomingMs === null) return false
      return (Date.now() - latestIncomingMs) > (24 * 60 * 60 * 1000)
    })
    const isPhotoSendBlocked = computed(() => {
      const fileType = String(uploadedFile.value && uploadedFile.value.file_type ? uploadedFile.value.file_type : '')
      return isConversationWindowExpired.value && fileType.indexOf('image/') === 0
    })

    async function openChatOfContact(contact){
      console.log('openChatOfContact', contact)
      loading.value = true
      selected_customer_data.value = contact
      selected_customer_photo.value = contact.member && contact.member.uuid
        ? 'https://rb.cloudedu.pro/studentPhoto/'+contact.member.uuid+'.jpg'
        : null
      activeContact.value = contact
      selected_customer.value = contact.whatsapp_mobile
      isHydratingCenter.value = true
      const leadCenterId = Number(contact.lead_center_id || contact.center_id || 0) || null
      changed_center.value = findCenterOptionById(leadCenterId)
      await nextTick()
      isHydratingCenter.value = false

      conversations.value = []
      conversation_page.value = 0
      hasConversationsMore.value = true

      await nextTick()
      await getConversions(contact, { prepend: false })
      await scrollToBottomInChatLog()
      loading.value = false
      debounceReloadContacts()
    }

    async function getConversions(contact, { prepend } = { prepend: false }){
      if (isLoadingConversations.value || !hasConversationsMore.value) return
      isLoadingConversations.value = true

      // scroll container element
      const ps = refChatLogPS.value
      const scrollEl = ps?.$el || ps
      const oldScrollHeight = scrollEl ? scrollEl.scrollHeight : 0
      const oldScrollTop = scrollEl ? scrollEl.scrollTop : 0
      try{
        const result = await fetchConversationsPage(contact, conversation_page.value)
        if (result.ok && result.list.length) {
          const newMsgs = result.list
          if (prepend) {
            conversations.value = [...newMsgs, ...conversations.value]
          } else {
            conversations.value = [...conversations.value, ...newMsgs]
          }
          conversations.value = conversations.value.sort(
            (a, b) => new Date(a.last_time) - new Date(b.last_time)
          )
          conversation_page.value += 1
          hasConversationsMore.value = result.hasMorePage
          await nextTick()
          if (prepend && scrollEl) {
            const newScrollHeight = scrollEl.scrollHeight
            scrollEl.scrollTop = oldScrollTop + (newScrollHeight - oldScrollHeight)
          }
        } else {
          hasConversationsMore.value = false
        }
        if (result.ok) {
          await refreshUnreadTotalToStorage()
        }
        mqShallShowLeftSidebar.value = false
      } finally {
        isLoadingConversations.value = false
      }
    }

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    // User Profile Sidebar
    // ? Will contain all details of profile user (e.g. settings, about etc.)
    const profileUserData = ref({})
    // ? Will contain id, name and avatar & status

    const shallShowUserProfileSidebar = ref(false)
    const showUserProfileSidebar = () => {
      store.dispatch('app-chat/getProfileUser')
        .then(response => {
          profileUserData.value = response.data
          shallShowUserProfileSidebar.value = true
        })
    }

    // Active Chat Contact Details
    const shallShowActiveChatContactSidebar = ref(false)

    // UI + SM Devices
    // Left Sidebar Responsiveness
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()
    const startConversation = () => {
      if (store.state.app.windowWidth < $themeBreakpoints.lg) {
        mqShallShowLeftSidebar.value = true
      }
    }

    async function handleSubmit() {
      if (!selected_customer.value) return
      if (isSending.value) return
      if (isPhotoSendBlocked.value) return
      isSending.value = true
      let sent = false
      try {
        if (uploadedFile.value.base64) {
          await sendMediaMessage()
          clearUpload()
          sent = true
          return
        }

        // 🔹 Text message
        if (chatInputMessage.value) {
          await sendTextMessage()
          sent = true
        }
      } finally {
        isSending.value = false
        if (sent) {
          refreshAfterSubmit()
        }
      }
    }

    async function sendMediaMessage() {
      const payload = {
        recipient: selected_customer.value,
        username: 'cloudfit',
        file: uploadedFile.value.base64,     // ✅ BASE64
        file_type: uploadedFile.value.file_type,
        file_name: uploadedFile.value.file_name,
      }

      const response = await sendWhatsappMediaMessage(vm.$http, payload)
      if (response.status !== 200 || response?.data?.result === false) {
        throw new Error('Failed to send media message')
      }
    }

    async function sendTextMessage(){
      if (!chatInputMessage.value) {
        return
      }

      const messageText = String(chatInputMessage.value || '').trim()
      if (!messageText) {
        return
      }

      if (isConversationWindowExpired.value) {
        const targetNumber = String(selected_customer.value || '').trim()
        const templatePayload = {
          number: targetNumber,
          recipient: targetNumber,
          country_code: '',
          text_message: messageText,
          username: 'cloudfit',
          by_admin: 'cloudfit',
        }

        try {
          const templateResponse = await vm.$http.post(
            process.env.VUE_APP_API_BASE + '/whatsapp/send-engagement-template/',
            templatePayload,
          )

          if (templateResponse?.data?.result === false) {
            vm.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: templateResponse?.data?.upsteam_message || templateResponse?.data?.upstream_message || templateResponse?.data?.message || 'Failed to send text message',
              },
            })
            return
          }
        } catch (error) {
          const errorData = error?.response?.data || {}
          vm.$toast({
            component: ToastificationContent,
            position: 'top-center',
            props: {
              title: 'Error',
              icon: 'XIcon',
              variant: 'danger',
              text: errorData?.upsteam_message || errorData?.upstream_message || errorData?.message || 'Failed to send text message',
            },
          })
          return
        }

        chatInputMessage.value = null
        return
      }

      const payload = {
        text_message: messageText,
        recipient: selected_customer.value,
        username: 'cloudfit',
      }

      const response = await sendWhatsappTextMessage(vm.$http, payload)
      if (response.status !== 200) {
        alert('Failed to send text message: ' + (response?.data?.upstream_message || 'Unknown error'))
        vm.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: response.data.upsteam_message,
              },
            })
      }

      chatInputMessage.value = null
    }

    return {
      // Filters
      // formatDate,

      // useChat
      resolveAvatarBadgeVariant,

      // Chat & Contacts
      chatsContacts,
      // Single Chat
      refChatLogPS,
      activeChat,
      loading,
      chatInputMessage,
      openChatOfContact,

      // User Profile Sidebar
      profileUserData,
      shallShowUserProfileSidebar,
      showUserProfileSidebar,

      // Active Chat Contact Details
      shallShowActiveChatContactSidebar,

      // UI
      perfectScrollbarSettings,

      // UI + SM Devices
      startConversation,
      mqShallShowLeftSidebar,
      // get contacts
      hasMore,
      isLoadingContacts,
      getContacts,
      filterContact,
      searchMobile,
      conversations,
      loadMoreConversations,
      isLoadingConversations,
      selected_customer,
      selected_customer_data,
      selected_customer_photo,
      isConversationWindowExpired,
      isPhotoSendBlocked,
      sendTextMessage,
      dropSink,
      isDragging,
      hasUpload,
      changed_center,
      centerOptions,
      get_center_data,
      isSending,
      isImageUpload,
      isVideoUpload,
      uploadedFileName,
      onDragOver,
      onDragEnter,
      onDragLeave,
      handleDrop,
      clearUpload,
      handleSubmit,
      uploadedPreviewUrl
      ,chatAppWindowEl
      ,chatFormEl
      ,openEmojiPicker
      ,insertEmoji
      ,emojiList
      ,frequentEmojiList
      ,isEmojiLoading
      ,change_pin
      ,unread
    }
  },
}
</script>

<style scoped>

.chat-send-row {
  display: flex;
  align-items: stretch;
  gap: 12px;              /* ✅ spacing between input and send button */
  width: 100%;
}

.vd-drop-zone {
  flex: 1;                /* ✅ drop zone takes remaining width */
  min-width: 0;
}

.emoji-btn {
  flex: 0 0 auto;
  min-height: 38px;
  padding-left: 12px;
  padding-right: 12px;
}

.emoji-grid {
  display: grid;
  grid-template-columns: repeat(10, minmax(0, 1fr));
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
  padding-right: 2px;
}

.emoji-grid--frequent {
  max-height: none;
  overflow: visible;
}

.emoji-section-title {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 6px;
}

.emoji-loading {
  text-align: center;
  color: #6b7280;
  font-size: 13px;
  padding: 12px 0;
}

.emoji-item {
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 8px;
  font-size: 20px;
  line-height: 1;
  padding: 8px 0;
  cursor: pointer;
}

.emoji-item:hover {
  background: #f9fafb;
}

.vd-drop-box{
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 54px;
  overflow: visible !important; /* ✅ don't clip the input */
}

.vd-drop-box.dragging {
  border: 2px dashed #7367f0 !important;
  background: rgba(115, 103, 240, 0.05);
}

.chat-expired-textarea {
  background-color: #fff9c4 !important;
}


.input-row{
  flex: 0 0 auto;               /* ✅ never shrink away */
  min-width: 0;
}
.upload-preview-card {
  display: flex;
  align-items: center;
  gap: 12px;

  padding: 10px 12px;
  border-radius: 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;

  max-width: 100%;
}

.preview-left {
  flex-shrink: 0;
}

/* Image / Video preview */
.preview-media {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 10px;
  background: #000;
}

/* File chip */
.file-chip {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 64px;
  height: 64px;
  border-radius: 10px;

  background: #eef2ff;
  color: #3730a3;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  padding: 6px;
}

/* Right side */
.preview-right {
  flex: 1;
  min-width: 0;
}

.file-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Remove button */
.remove-btn {
  margin-top: 4px;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
}

.send-btn {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  padding-left: 18px;
  padding-right: 18px;
  min-height: 38px;
  height: auto;
  margin-bottom: 0;
}
.send-btn--disabled,
.send-btn:disabled {
  background: #d1d5db !important;   /* grey */
  border-color: #d1d5db !important;
  color: #6b7280 !important;
  cursor: not-allowed !important;
  opacity: 1 !important;            /* keep solid grey (not faded) */
  pointer-events: none !important;  /* extra safety */
}
.chat-app-window .chat-app-form {
  padding: 1rem;
}

.chat-app-window .active-chat {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.chat-app-window .chat-app-form.chat-app-form--flex {
  position: relative !important;
  bottom: auto !important;
  left: auto !important;
  right: auto !important;
  flex: 0 0 auto;
  height: auto !important;
  min-height: 0 !important;
  max-height: none !important;
}

.chat-app-window .chat-app-form.chat-app-form--flex .chat-send-row {
  align-items: stretch;
}

.chat-app-window .chat-app-form.chat-app-form--flex textarea.form-control {
  min-height: 38px;
  height: auto;
  overflow-y: auto;
}

.chat-app-window .user-chats {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  height: auto !important;
}
</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>